import { GlossaryDataModel } from '../../../types/info.interface';
import { FullPageModule, SectionTitle } from '../../../styles/global.styles';
import {
  EntriesContainer,
  GlossaryDescription,
  GlossaryItem,
  GlossaryTitle,
  GroupContainer,
  GroupTitle,
  ColumnContainer,
} from './glossary.styles';
import { FormattedMessage } from 'react-intl';

interface GlossaryGroup {
  key: string;
  title: string;
  defaultTitle: string;
  items: Array<{ key: string; title: string; description: string }>;
}

export function Glossary(props: GlossaryDataModel) {
  /*  "glossary.information.title": "Información Principal",
  "glossary.supply_and_demand": "Oferta y demanda",
  "glossary.who_lives": "¿Quién Vive en la Zona?",
  

  "glossary.recent_similar_witnesses.RecentSimilarWitnesses.title": "Testigos similares recientes",
  "glossary.recent_similar_witnesses.RecentSimilarWitnesses.description": "Precio de cierre estimado en testigos recientes en la zona relativas a inmuebles de similares características en cuanto a su tipología y tamaño.",
 */

  const column1Groups = [
    {
      key: 'main',
      title: 'glossary.information.title',
      defaultTitle: 'Información Principal',
      items: props.main,
    },
    {
      key: 'supply_and_demand',
      title: 'glossary.supply_and_demand',
      defaultTitle: 'Oferta y Demanda',
      items: props.supply_and_demand,
    },
  ].filter((group) => group.items);

  const column2Groups = [
    {
      key: 'know_the_area',
      title: 'glossary.know_the_area.knowTheZone.title',
      defaultTitle: 'Conoce la Zona',
      items: props.know_the_area,
    },
    {
      key: 'recent_similar_witnesses',
      title: 'glossary.recent_similar_witnesses.recentSimilarWitnesses.title',
      defaultTitle: 'Testigos Similares Recientes',
      items: props.recent_similar_witnesses,
    },
    {
      key: 'who_lives_in_the_area',
      title: 'glossary.who_lives',
      defaultTitle: '¿Quién Vive en la Zona?',
      items: props.who_lives_in_the_area,
    },
    {
      key: 'valuation',
      title: 'glossary.valuation.valuation.title',
      defaultTitle: 'Modelos de valoración',
      items: props.valuation,
    },
  ].filter((group) => group.items);

  const renderGroup = (group: GlossaryGroup, index: number) => (
    <GroupContainer key={index}>
      <GroupTitle>
        <FormattedMessage
          id={group.title}
          defaultMessage={group.defaultTitle}
        />
      </GroupTitle>
      {group.items.map((item, itemIndex: number) => (
        <GlossaryItem key={itemIndex}>
          {`glossary.${group.key}.${item.key}.title` !== group.title && (
            <GlossaryTitle>
              <FormattedMessage
                id={`glossary.${group.key}.${item.key}.title`}
                defaultMessage={item.title}
              />
            </GlossaryTitle>
          )}
          <GlossaryDescription>
            <FormattedMessage
              id={`glossary.${group.key}.${item.key}.description`}
              defaultMessage={item.description}
            />
          </GlossaryDescription>
        </GlossaryItem>
      ))}
    </GroupContainer>
  );

  return (
    <FullPageModule>
      <SectionTitle>
        <FormattedMessage id="glossary.title" defaultMessage="Glosario" />
      </SectionTitle>
      <EntriesContainer>
        <ColumnContainer>{column1Groups.map(renderGroup)}</ColumnContainer>
        <ColumnContainer>{column2Groups.map(renderGroup)}</ColumnContainer>
      </EntriesContainer>
    </FullPageModule>
  );
}
